export enum CompleteTypes {
  INFORMATION_CHECK = 'Information check',
  FINANCE_PLAN = 'Finance plan',
  DOCUMENTS = 'Documents',
  INTERVIEW = 'Interview',
  ALL = 'All',
}
